import ExcelJS from "exceljs";
import { formatDateTimeWithoutSec } from "../../Common/helper/helpar";
import useIndependentStore from "./store/independentEngineerStore";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { CorporationStore } from "../corporation_master/CorporationStore";

export const ExportIndependentEngineerData = () => {

    const { independentEngineerData } = useIndependentStore();
    const { CorporationDetails } = CorporationStore();

    const getCorporationName = (item) => {
        const corp = CorporationDetails.find(
            (c) => c.corporationId === (item.corporationId || item.organizationId)
        );
        return corp?.corporationName || item.corporationName || "-";
    };
  
  const downloadExcel = async () => {
    const { FromDateTime, ToDateTime } = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};
    // Get current date/time for header
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      FromDateTime && ToDateTime ? `(${formatDateTimeWithoutSec(FromDateTime)} to ${formatDateTimeWithoutSec(ToDateTime)})` : "";
    // Determine report type based on the "circle" flag
    const reportTitle = `Independent Enginner`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 6);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 6);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Name",
      "IE Engineer ID",
      "Corporation",
      "Associated Transfer Station",
      "Status",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    independentEngineerData.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.name,
        item.ieEngineerId,
        getCorporationName(item),
        item.associatedTransferStationNames?.join(", "),
        item.isActive ? "Active" : "InActive",
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 8 },   // S.No
      { width: 25 },  // Name
      { width: 20 },  // IE Engineer ID
      { width: 25 },  // Corporation
      { width: 60 },  // Associated Transfer Station
      { width: 15 },  // Status
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "IndependentEngineer.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  // Export as PDF
  const downloadPDF = () => {
    const doc = new jsPDF();

    // Centered Title
    doc.text("Independent Engineer", doc.internal.pageSize.getWidth() / 2, 10, { align: "center" });

    // Generate table with centered text & headers
    autoTable(doc, {
      head: [["S.No", "Name", "IE Engineer ID", "Corporation", "Associated Transfer Station", "Status"]],
      body: independentEngineerData.map((row, index) => [
        { content: index + 1, styles: { halign: "center" } },
        { content: row.name || "N/A", styles: { halign: "center" } },
        { content: row.ieEngineerId || "N/A", styles: { halign: "center" } },
        { content: getCorporationName(row), styles: { halign: "center" } },
        { content: row.associatedTransferStationNames?.join(", ") || "N/A", styles: { halign: "center" } },
        { content: row.isActive ? "Active" : "InActive", styles: { halign: "center" } },
      ]),
      margin: { top: 20 },
      styles: { halign: "center", fontSize: 8 },
      headStyles: { halign: "center", fontStyle: "bold" },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: 30 },
        2: { cellWidth: 28 },
        3: { cellWidth: 30 },
        4: { cellWidth: 55 },
        5: { cellWidth: 20 },
      },
    });

    // Save the PDF
    doc.save("Independent Engineer.pdf");
  };


  return (
    <div className="d-flex">
       {/* PDF Export Button */}
       <button type="button" className="btn btn-excel" onClick={downloadPDF}>
        <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
      </button>
   
    <button
      type="reset"
      className="btn btn-excel"
      onClick={downloadExcel}
    >
      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
    </button>
    </div>
  )
}